module.exports = __webpack_public_path__ + "img/kjicon6.877a6e6c.svg";